import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import { useSelector } from "react-redux";

function QualificationsInformation({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});
  const qualifications = userDetails?.extraInformation?.qualifications || {};

  return (
    <div
      id="qualificationsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex flex-col items-start gap-3 self-stretch">
        <div className="flex justify-between items-center self-stretch">
          <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
            {t("qualifications")}
          </span>
          {isShowEditIcon && (
            <EditIcon
              className={`cursor-pointer ${
                isEditShowEditOnHover ? "visible" : "invisible"
              }`}
              onClick={onEditClick}
            />
          )}
        </div>
      </div>

      <div className="flex items-start content-start gap-x-6 gap-y-[30px] self-stretch flex-wrap">
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("university")}
            subTitle={`${qualifications?.university ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("qualification")}
            subTitle={`${qualifications?.qualification ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("major")}
            subTitle={`${qualifications?.major ?? "-"}`}
          />
        </div>{" "}
      </div>
    </div>
  );
}

QualificationsInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default QualificationsInformation;
